import Card from "./Card";
import type { Client } from "../types";

interface ClientCardProps {
  client: Client;
  onClick: () => void;
}

export default function ClientCard({ client, onClick }: ClientCardProps) {
  return (
    <Card onClick={onClick} className="mb-2">
      <div className="flex items-center justify-between">
        <div className="min-w-0">
          <h3 className="font-semibold text-gray-900 truncate">{client.name}</h3>
          {client.company && (
            <p className="text-sm text-gray-500 truncate">{client.company}</p>
          )}
        </div>
        {client.source === "spark_os" && (
          <span className="ml-2 w-5 h-5 flex items-center justify-center text-xs font-medium bg-blue-100 text-blue-700 rounded-full flex-shrink-0">
            S
          </span>
        )}
      </div>
    </Card>
  );
}
